// !--- Trryst Confidential. Please do not share or distribute without approval from Trryst (CSuite Ltd.)
import * as React from "react";
import SimpleNotificationCard from "blocks/views/Notifications/foundations/SimpleNotificationCard";
import { getS3ImageWrapper } from "@app21/core";

const FilesAdded = ({ notification, viewContext, index }) => {
  const { payload } = notification;
  let dummyPicture = `images/suitestockimages/suiteImage-5.jpg`;

  let fileSummaryInfo;
  if (payload?.files?.length > 1) {
    fileSummaryInfo = `${payload.files?.length} files.`;
  } else {
    fileSummaryInfo = `${payload?.files && payload?.files[0]?.fileName}`;
  }
  const data = {
    message: `${payload?.uploadingUserFullName || "Suite Member"} has added ${
      fileSummaryInfo || "a file"
    }`,
    avatar: getS3ImageWrapper(payload?.uploadingUserImage || dummyPicture),
    subHeader: notification.createdAt,
  };
  return (
    <SimpleNotificationCard
      data={data}
      notification={notification}
      viewContext={viewContext}
      index={index}
    />
  );
};

export default FilesAdded;
